var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({class:_vm.columnOrder},'div',_vm.columnEditable,false),[_vm._l((_vm.data.widgets),function(widget){return [_vm._t("default",null,{"widget":widget,"columnSpaceLeft":_vm.columnSpaceLeft})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }